/**
 * Auth-only Supabase client for the /dashboard frontend.
 *
 * This client is used EXCLUSIVELY for authentication operations.
 * ALL DATA OPERATIONS must go through VITE_API_URL (/api server).
 */
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
